import React, { FunctionComponent } from 'react';
import styles from './CardTitle.module.scss';
import { _t } from 'app/utils/i18n';
import PopperQuestionMark from '../PopperQuestionMark';

interface Props {
  title: string;
  compId?: string;
  showBorderBottom?: boolean;
  hideIcon?: boolean;
  maxFontSize?: boolean;
  isLabel?: boolean;
  withoutMarginButton?: boolean;
  style?: any;
}

const CardTitle: FunctionComponent<Props> = ({
  title = _t('basic:card_title_placeholder'),
  showBorderBottom = false,
  hideIcon,
  maxFontSize = false,
  compId,
  isLabel,
  withoutMarginButton,
  style,
}) => {
  return (
    <div
      className={`${styles.CardTitle} ${
        isLabel ? styles.LabelStyleContainer : ''
      } ${withoutMarginButton ? styles.withoutMarginButton : ''}`}
      id={`${compId}-title`}
      data-testid="CardTitle-title"
    >
      <div
        data-testid="title-holder"
        className={` ${
          showBorderBottom ? styles.CardTitleTextBorder : styles.CardTitleText
        } ${maxFontSize ? styles.MaxFontSize : null} ${
          isLabel ? styles.LabelStyleTitle : styles.NormalStyleTitle
        } `}
        title={title}
        style={{ ...style }}
      >
        {title}
      </div>
      {!hideIcon && <PopperQuestionMark isLabel={isLabel} compId={compId} />}
    </div>
  );
};

export default CardTitle;
